import React from 'react';
import { motion } from 'framer-motion';
const CTA_BOOK_ONLINE_SVG = 'https://cdn.magicpatterns.com/uploads/e3r1rj47crZgXHRpz1A67c/sj-website-cta-book-online.svg';
export function WhyChooseUsSection() {
  return <section className="bg-light py-24 md:py-32 relative z-20" data-id="element-188">
      <div className="container mx-auto px-6 md:px-12" data-id="element-189">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-190">
          {/* Left Heading */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-4" data-id="element-191">
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-heading font-bold text-primary uppercase leading-[0.85] tracking-tighter mb-8 lg:mb-0" data-id="element-192">
              Why <br data-id="element-193" /> Choose <br data-id="element-194" /> Us?
            </h2>
          </motion.div>

          {/* Right Image & Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="lg:col-span-8 relative" data-id="element-195">
            <div className="h-[500px] md:h-[600px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-196">
              <img src="https://cdn.magicpatterns.com/uploads/fvLGuhK8ZtKCcr8Dpv4hcg/sj-website-why-choose-us.png" alt="Beautiful living room" className="w-full h-full object-cover" data-id="element-197" />
            </div>

            {/* Floating Info Card */}
            <div className="absolute -bottom-12 left-6 md:left-12 right-6 md:right-auto md:w-[500px] bg-[#2A6B7C] text-white p-8 md:p-12 rounded-2xl shadow-2xl z-10" data-id="element-198">
              <p className="text-lg leading-relaxed mb-8 font-light" data-id="element-199">
                We deliver an outstanding service backed by our 100%
                satisfaction guarantee. Our team is professional, experienced,
                and insured. You won't have to worry about home cleaning or
                commercial cleaning again, and have more time for what matters
                most to you.
              </p>

              <div className="flex items-center justify-between border-t border-white/20 pt-8" data-id="element-200">
                <div className="text-sm text-white/60" data-id="element-201">
                  <p data-id="element-202">Fully Insured & Vetted</p>
                  <p data-id="element-203">100% Satisfaction Guarantee</p>
                </div>

                <a href="#home" className="hover:opacity-80 transition-opacity" data-id="element-204">
                  <img src={CTA_BOOK_ONLINE_SVG} alt="Book Online" className="h-10 md:h-12" data-id="element-205" />
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}